import React, { Component } from 'react'
import { buildTitle } from '../../components/UserProfile'
import { Row, Col } from 'react-flexbox-grid'
import CollapsibleSection from '../../controls/CollapsibleSection'
import PasswordField from '../../controls/PasswordField'
import InputField from '../../controls/InputField'
import RBButton from '../../controls/RBButton'
import { localize } from '../../util/Localizer'
import { injectIntl } from 'react-intl'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import { connect } from 'react-redux'
import { updateUser } from '../../redux/actions/userProfileActions'
import { push } from 'connected-react-router'
import Tooltip from '../../controls/Tooltip'
import { Colors } from '../../theme'

class EmailAddress extends Component {
  constructor (props) {
    super(props)
    this.checkEnter = this.checkEnter.bind(this)
    this.enterSave = this.enterSave.bind(this)
    this.validate = this.validate.bind(this)
    this.disableButton = this.disableButton.bind(this)
    this.saveInfo = this.saveInfo.bind(this)
    this.redirect = this.redirect.bind(this)
    this.state = {
      ...props.value,
      username: props.username,
      password: '',
      newEmail: '',
      newEmailConfirm: '',
      expanded: false
    }
    this.baseState = this.state
  }

  componentDidMount () {
    this.validate()
    this.reset()
  }

  reset () {
    const base = this.baseState
    this.setState({ password: base.password })
  }

  redirect () {
    window.location.reload()
  }

  saveInfo () {
    const profileUpdate = {
      username: this.state.username,
      currentpassword: this.state.password,
      email: this.state.newEmail,
      confirmEmail: this.state.newEmailConfirm
    }
    this.props.updateUser(profileUpdate, (data) => {
      this.props.saveComplete(data)
    }, (data) => {
      this.props.errorOnSave(data)
    })
  }

  checkEnter (event) {
    const code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      this.setState({ enterSave: true }, this.validate)
    }
  }

  validate () {
    if (!this.state || !this.state.newEmail) return

    const state = this.state
    const newState = {}
    const emailReg = new RegExp('[^@]+@[^@]+\\.[^@]+')
    // check if email is valid
    if (state.newEmail.length !== 0 && !emailReg.test(state.newEmail)) {
      newState.invalidEmail = localize('pages.userProfile.invalidEmailError')
    } else {
      newState.invalidEmail = null
    }

    // check if new email is valid
    if (state.newEmail.length !== 0 && !emailReg.test(state.newEmail)) {
      newState.invalidNewEmail = localize('pages.userProfile.invalidEmailError')
    } else {
      newState.invalidNewEmail = null
    }

    // check for matches in email, if matches reset error state
    if ((state.newEmailConfirm.length !== 0) && (state.newEmail !== state.newEmailConfirm) && emailReg.test(state.newEmail)) {
      newState.confirmEmailError = localize('pages.userProfile.confirmEmailError')
    } else {
      newState.confirmEmailError = null
    }

    if (state.newEmail.length !== 0 && state.newEmailConfirm.length === 0 && emailReg.test(state.newEmail)) {
      newState.noConfirmEmail = localize('pages.userProfile.noConfirmEmail')
    } else {
      newState.noConfirmEmail = null
    }
    this.setState(newState, this.enterSave)
  }

  enterSave () {
    if (this.state.enterSave) {
      this.setState({ enterSave: false })
      if (!this.disableButton()) {
        this.saveInfo()
      }
    }
  }

  disableButton () {
    const s = this.state

    if (!s.password || !s.newEmailConfirm || !s.newEmail) {
      return true
    }

    return !(!s.invalidEmail &&
      !s.invalidNewEmail &&
      !s.noConfirmEmail &&
      !s.confirmEmailError)
  }
  render () {
    const values = this.state

    return (
      <div>
        <CollapsibleSection
          id='email'
          showMuiBorder={false}
          isProfile={this.props.isProfile}
          heading={buildTitle('pages.userProfile.title.email', 'pages.userProfile.subtitle.email')}
          expanded={this.props.expanded}
          onExpanded={(key, expanded) => this.props.onExpanded(expanded)}>
          <Row style={{ width: '100%' }}>
            <Col xs={11} md={6} >
              <br />
              <PasswordField
                id='emailPassword'
                type='password'
                fullWidth
                floatingLabelText={localize('pages.userProfile.currentPassword')}
                className='password'
                autoComplete='off'
                onChange={(e, password) => this.setState({ password })}
                onKeyPress={this.checkEnter}
                value={values.password}
                onBlur={this.validate}
                errorText={values.currentPassError}
              />
              <div className='tooltipInput'>
                <InputField
                  id='newEmail'
                  type='email'
                  fullWidth
                  floatingLabelText={localize('pages.userProfile.changeEmail')}
                  value={values.newEmail}
                  onChange={(e, newEmail) => this.setState({ newEmail }, () => this.validate())}
                  onKeyPress={this.checkEnter}
                  onBlur={this.validate}
                  errorText={values.invalidNewEmail ? values.invalidNewEmail : values.confirmEmailError}
                  adornment={
                    <Tooltip title={localize('common.tooltip.changeEmail')} placement="right-end">
                      <IconButton >
                        <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
                      </IconButton>
                    </Tooltip>
                  }
                />

              </div>
              <InputField
                id='newEmailConfirm'
                type='email'
                fullWidth
                floatingLabelText={localize('pages.userProfile.confirmEmail')}
                value={values.newEmailConfirm}
                onChange={(e, newEmailConfirm) => this.setState({ newEmailConfirm }, () => this.validate())}
                onKeyPress={this.checkEnter}
                onBlur={this.validate}
                errorText={values.noConfirmEmail ? values.noConfirmEmail : values.confirmEmailError}
              />
            </Col>
          </Row>
          <div className='buttonContainer fltRight'>
            <RBButton
              variant='outlined'
              id='cancelBtn'
              label={localize('common.cancel')}
              onClick={this.redirect} />
            <RBButton
              variant='contained'
              id='saveBtn'
              label={localize('common.saveUpdates')}
              primary
              onClick={this.saveInfo}
              disabled={this.disableButton()}
              loading={this.props.pageLoading}
            />
          </div>
        </CollapsibleSection>
        <hr />
      </div>
    )
  }
}
function mapStateToProps (state, ownProps) {
  return Object.assign({}, ownProps, {
    pageLoading: state.UserProfileReducers.isFetching
  })
}
const ConnectedEmailAddress = connect(mapStateToProps, { updateUser, push })(injectIntl(EmailAddress))
export default ConnectedEmailAddress



// WEBPACK FOOTER //
// ./src/widgets/userProfile/EmailAddress.js